// Pages
import { licenseGuard } from '@/router/guards'
import RouterView from '@/components/pages/RouterView/Router'

import Operations from '@/components/pages/Operations/Operations.vue'
import Operation from '@/components/pages/Operations/Operation.vue'
import AddOperation from '@/components/pages/Operations/AddOperation.vue'
import EditOperation from '@/components/pages/Operations/EditOperation.vue'
import UploadOperations from '@/components/pages/Operations/OperationUpload'
import NurseUploadOperations from '@/components/pages/Operations/NurseOperationUpload'

export default {
  path: '/operations',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      name: 'all-operations',
      component: Operations,
      meta: {breadcrumb: 'My Operations'}
    },
    {
      path: 'add-operation',
      component: AddOperation,
      name: 'add-operation',
      meta: {breadcrumb: 'Schedule New Operation'},
      //beforeEnter: licenseGuard
    },
    {
      path: 'upload-operations',
      component: UploadOperations,
      name: 'upload-operations',
      meta: {breadcrumb: 'Bulk Upload Operations'},
      //beforeEnter: licenseGuard
    },
    {
      path: 'nurse-upload-operations',
      component: NurseUploadOperations,
      name: 'nurse-upload-operations',
      meta: {breadcrumb: 'Nurse Bulk Upload Operations'},
      //beforeEnter: licenseGuard
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: Operation,
          props: true,
          name: 'view-operation'
        },
        {
          path: 'edit',
          name: 'edit-operation',
          props: true,
          component: EditOperation,
          meta: {breadcrumb: 'Edit'},
          //beforeEnter: licenseGuard
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/operations.js